/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Region = {
    UsIowa: 'us-iowa',
    EuropeBelgium: 'europe-belgium',
    AsiaJapan: 'asia-japan',
    EuropeEngland: 'europe-england',
    AustraliaSydney: 'australia-sydney'
} as const;
export type Region = typeof Region[keyof typeof Region];


export function instanceOfRegion(value: any): boolean {
    for (const key in Region) {
        if (Object.prototype.hasOwnProperty.call(Region, key)) {
            if (Region[key as keyof typeof Region] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RegionFromJSON(json: any): Region {
    return RegionFromJSONTyped(json, false);
}

export function RegionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Region {
    return json as Region;
}

export function RegionToJSON(value?: Region | null): any {
    return value as any;
}

export function RegionToJSONTyped(value: any, ignoreDiscriminator: boolean): Region {
    return value as Region;
}

